<template>
  <div class="layout" :class="settings.theme_orientation">
      <div class="container" :style="style_left" ref="element_content_left" :class="{[props.left_content_class]: true, 'column-split' : column_split}" >
          <slot name="left-content" />
      </div>

      <div class="resizer" @mousedown="onMouseDown($event)" ref="resizer"></div>

      <div class="container" :style="style_right" :class="props.right_content_class" ref="element_content_right">
          <slot name="right-content" />
      </div>

      <!-- <OfflineAlert v-if="false" /> -->

  </div>
</template>

<script setup>
import { ref, reactive, watch, onBeforeMount, onUnmounted, defineProps, nextTick } from 'vue';
import LocalStorageService                                                         from '@/js/Shared/Services/Storage/LocalStorageService';
import LayoutSettingsController                                                    from '@/js/Webmail/LayoutSettingsController';
import DomController from '@/js/Webmail/DomController';
// import OfflineAlert                                                                from '../content/OfflineAlert.vue';

const props = defineProps({
  left_content_class: {
    type    : String,
    default : null,
  },

  right_content_class: {
    type    : String,
    default : null,
  },
})

const settings             = LayoutSettingsController;
const column_split         = ref(false);
const colum_split_width    = 500;
const style_right          = reactive({
  'flex-grow'  : 1,
  'flex-shrink': 1,
  'flex-basis' : '0%',
});

const style_left           = reactive({
  'flex-grow'  : 1,
  'flex-shrink': 1,
  'flex-basis' : '0%',
});

const element_content_left   = ref(null);
const element_content_right  = ref(null);

let offset_left    = null;
let offset_right   = null;
let offset_total   = 0;
let flex_grow_size = 0;
let last_position  = 0;

onBeforeMount(async () => {
  let storage = getStorage();
  setFlexGrow(storage.c1, storage.c2);
  await nextTick();
  setColumSplit();
})

onUnmounted(() => {
  removeListeners();
})

watch(() => [settings.theme_orientation], (current_value, old_value) => {
  if (current_value === old_value) {
    return;
  }

  setFlexGrow(1, 1);
  saveStorage();
});

const onMouseDown = (event) => {
  setListeners();
  setBodyClasses();

  (settings.theme_orientation === 'vertical')
    ? setVerticalData(event)
    : setHorizontalData(event);
}

const onMouseMove = (event) => {
  (settings.theme_orientation === 'vertical')
    ? recalculateLayout(event.pageY)
    : recalculateLayout(event.pageX);
}

const onMouseStop = (e) => {
  if (e.button !== 0) {
    return;
  }

  setDocumentCursor('default');
  removeListeners();
  removeBodyClasses();
  saveStorage();
}

const onContextMenu = (e) => {
  e.preventDefault();
}

const setListeners = () => {
  window.addEventListener('mousemove'  , onMouseMove);
  window.addEventListener('mouseup'    , onMouseStop);
  window.addEventListener('mouseleave' , onMouseStop);
  window.addEventListener('contextmenu', onContextMenu);
}

const removeListeners = () => {
  window.removeEventListener('mousemove' , onMouseMove);
  window.removeEventListener('mouseup'   , onMouseStop);
  window.removeEventListener('mouseleave', onMouseStop);
  window.removeEventListener('click'     , onMouseStop);
  window.removeEventListener('contextmenu', onContextMenu);
};

const setColumSplit = () => {
  column_split.value = (element_content_left.value.offsetWidth > colum_split_width) ? true : false;
}

const setHorizontalData = (event) => {
  setDocumentCursor('ew-resize');
  setLastPosition(event.pageX);
  setOffsetLeft(element_content_left.value.offsetWidth);
  setOffsetRight(element_content_right.value.offsetWidth);
  setOffsetTotal();
  setFlexGrowSize();
}

const setVerticalData = (event) => {
  setDocumentCursor('ns-resize');
  setLastPosition(event.pageY);
  setOffsetLeft(element_content_left.value.offsetHeight);
  setOffsetRight(element_content_right.value.offsetHeight);
  setOffsetTotal();
  setFlexGrowSize();
}

const recalculateLayout = (mouse_position) => {
  setOffsetLeft(offset_left   + (mouse_position - last_position));
  setOffsetRight(offset_right - (mouse_position - last_position));
  setLastPosition(mouse_position);
  setColumSplit();

  if (offset_left < 0) {
      setLastPosition(mouse_position - offset_left);
      setOffsetRight(offset_right + offset_left);
      setOffsetLeft(0);

  }
  if (offset_right < 0) {
      setLastPosition(mouse_position + offset_right);
      setOffsetLeft(offset_left + offset_right);
      setOffsetRight(0);
  }

  setFlexGrow(
    flex_grow_size * (offset_left / offset_total),
    flex_grow_size * (offset_right / offset_total),
  )
}

const setBodyClasses = () => {
  DomController.setBodyClass('noSelect');
}

const removeBodyClasses = () => {
  DomController.removeBodyClass('noSelect');
}

const setDocumentCursor = (cursor) => {
  document.body.style.cursor = cursor;
}

const setOffsetLeft = (left) => {
  offset_left = left;
}

const setOffsetRight = (right) => {
  offset_right = right;
}

const setOffsetTotal = () => {
  offset_total = offset_left + offset_right;
}

const setFlexGrowSize = () => {
  flex_grow_size = style_left['flex-grow'] + style_right['flex-grow']
}

const setLastPosition = (position) => {
  last_position = position;
}

const setFlexGrow = (left, right) => {
  style_left['flex-grow']  = left;
  style_right['flex-grow'] = right;
}

const saveStorage = () => {
  LocalStorageService.setObject('s_rml', {
    c1: style_left['flex-grow'],
    c2: style_right['flex-grow']
  })
}

const getStorage = () => {
  return LocalStorageService.getObject('s_rml', {c1: 1, c2: 1})
}
</script>